<!--访视信息-->
<script setup>
import { reactive, onMounted, computed } from "vue";
import { useCrfStore } from "@/stores/crf";
const crfStore = useCrfStore();

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null,
  index: null,
});

/**
 * 8 9 10
 */


// 表单对象
const model = reactive(props.formModel);

const options = ["上海同济大学附属同济医院",
  "上海中医药大学附属曙光医院",
  "上海交通大学附属第一人民医院",
  "上海交通大学医学院附属第九人民医院",
  "上海交通大学医学院附属仁济医院",
  "上海交通大学医学院附属瑞金医院",
  "复旦大学附属公共卫生临床中心",
  "复旦大学附属华山医院",
  "复旦大学附属儿科医院",
  "复旦大学附属中山医院",
  "无锡市第五人民院",
  "南京鼓楼医院",
  "南京市第二医院",
  "安徽医科大第二附属医院",
  "山东省立医院",
  "南方医院",
  "深圳市第三人民医院",
  "联勤保障部队第九〇〇医院",
  "福建医科大学第一附属医院",
  "云南省第一人民医院",
  "南昌大学第一附属医院",
  "新疆医科大学第一附属医院"];

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  // console.log(model.fields,"crfFGields")
  // console.log(props.type,"props.type")
  return model.fields[`${props.type}`];
});
// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
//访视日期必须大于上一个访视日期
const disabledDate = (time) => {
 
 return time.getTime() < new Date(aaa()).getTime() 
}
let aaa = () =>{
    // console.log(props,'props')
    // console.log(props.index,'props.index')
    if(props.index == 2){
         const afterDateI = crfStore.forms[props.index+ 1].type;
      const afterDate =  props.formModel.fields?.[afterDateI]
      if(!afterDate?.['访视日期']) {
        return;
      }
    }
    if(props.index < 3){
      return ''
    }
    const beforeDateI = crfStore.forms[props.index- 1].type;
    // console.log(props.formModel,beforeDateI,'props.formModel')
    const beforeDate =  props.formModel.fields?.[beforeDateI]
    if(!beforeDate?.['访视日期']) {
      return;
    }
    return beforeDate?.['访视日期']
    console.log(beforeDate?.['访视日期'],'beforeDate')
}
aaa()
;
</script>

<template>
  <template v-if="crfFields">
    <!-- <el-form-item label="访视日期" :prop="itemProp('访视日期')"
                  :rules="crfStore.textRules('访视日期',true)" class="picker"> -->
      <el-date-picker v-model="crfFields['访视日期']"
                      type="date" placeholder="选择访视日期"
                      :disabled-date="disabledDate"
                      value-format="YYYY-MM-DD" />
    <!-- </el-form-item> -->
    <!-- <el-form-item label="访视地点" :prop="itemProp('访视地点（医院）')"
                  :rules="crfStore.textRules('访视地点（医院）',true)">
      <el-select v-model="crfFields['访视地点（医院）']" filterable placeholder="请选择访视地点（医院）"
                 style="min-width:300px">
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
    </el-form-item> -->
  </template>
</template>

<style scoped>
</style>